package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdExternalLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.AboutWorkCardStyle
import com.anjuros.website.redesign.styles.AboutWorkCopyStyle
import com.anjuros.website.redesign.styles.AboutWorkFactsRowStyle
import com.anjuros.website.redesign.styles.AboutWorkFactsStyle
import com.anjuros.website.redesign.styles.AboutWorkShotsStyle
import com.anjuros.website.redesign.styles.AboutWorkStatusStyle
import com.anjuros.website.redesign.styles.AboutWorkTagsStyle
import com.anjuros.website.redesign.styles.AboutWorkTopStyle
import com.anjuros.website.redesign.styles.RdArrowStyle
import com.anjuros.website.redesign.styles.RdH2Style
import com.anjuros.website.redesign.styles.RdPrimaryButtonStyle
import com.anjuros.website.redesign.styles.RdSectionFlushTopStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdExternal
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Anchor of the client project, used by the "See my work" button in the closing card. */
/** Hidden for now; set to true to show the real client project on the About page again. */
const val SHOW_CLIENT_WORK = false

const val ABOUT_WORK_ID = "work"

private val WorkFacts = listOf(
    RdText.ABOUT_WORK_CHALLENGE_LABEL to RdText.ABOUT_WORK_CHALLENGE,
    RdText.ABOUT_WORK_RESULT_LABEL to RdText.ABOUT_WORK_RESULT,
)

/** The live guesthouse website: laptop and phone screenshots, challenge, result and a link to the site. */
@Composable
fun AboutWorkSection() {
    val shotsLabel = LocalText(RdText.ABOUT_WORK_SHOTS_LABEL)
    RdSection(
        id = ABOUT_WORK_ID,
        labelledBy = "work-h",
        modifier = RdSectionStyle.toModifier().then(RdSectionFlushTopStyle.toModifier()),
    ) {
        RdTag("article", AboutWorkCardStyle.toModifier()) {
            Div(AboutWorkShotsStyle.toModifier().attrsModifier { attr("role", "group"); attr("aria-label", shotsLabel) }.toAttrs()) {
                RdPicture(RdImage.WORK_GUESTHOUSE_LAPTOP, LocalText(RdText.ABOUT_WORK_LAPTOP_ALT))
                RdPicture(RdImage.WORK_GUESTHOUSE_PHONE, LocalText(RdText.ABOUT_WORK_PHONE_ALT))
            }
            Div(AboutWorkCopyStyle.toModifier().toAttrs()) {
                Div(AboutWorkTopStyle.toModifier().toAttrs()) {
                    RdEyebrow(RdText.ABOUT_WORK_EYEBROW)
                    Span(AboutWorkStatusStyle.toModifier().toAttrs()) { Text(LocalText(RdText.ABOUT_WORK_STATUS)) }
                }
                H2(RdH2Style.toModifier().id("work-h").toAttrs()) { Text(LocalText(RdText.ABOUT_WORK_TITLE)) }
                RdTag("dl", AboutWorkFactsStyle.toModifier()) {
                    WorkFacts.forEach { (term, value) ->
                        Div(AboutWorkFactsRowStyle.toModifier().toAttrs()) {
                            RdTag("dt") { Text(LocalText(term)) }
                            RdTag("dd") { Text(LocalText(value)) }
                        }
                    }
                }
                Ul(AboutWorkTagsStyle.toModifier().toAttrs()) { rdList(LocalText(RdText.ABOUT_WORK_TAGS)).forEach { Li { Text(it) } } }
                RdExternalLink(RdExternal.GUESTHOUSE, RdPrimaryButtonStyle.toModifier()) {
                    Text(LocalText(RdText.ABOUT_WORK_LINK))
                    Span(RdArrowStyle.toModifier().attrsModifier { attr("aria-hidden", "true") }.toAttrs()) { Text("↗") }
                }
            }
        }
    }
}
